import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { baseUrl } from "../utils/utils";
import moment from "moment";

var today = new Date();
today.setHours(today.getHours() - 6);

export const get_temp_data = createAsyncThunk("temp", async (data) => {
  var formdata = new FormData();
  formdata.append("userid", data.userid);
  formdata.append("branchid", data.id);
  formdata.append("start", moment(today).format("YYYY-MM-DD HH:mm:ss"));
  formdata.append("end", moment(new Date()).format("YYYY-MM-DD HH:mm:ss"));

  const responce = await fetch(baseUrl + "templist", {
    method: "POST",
    body: formdata,
  });
  const res = await responce.json();
  console.log("temp", res);
  return res;
});

const tempSlice = createSlice({
  name: "temp",
  initialState: {
    temp_list: [],
    temp_loading: false,
  },
  extraReducers: (builder) => {
    builder.addCase(get_temp_data.pending, (state, action) => {
      state.temp_loading = true;
    });
    builder.addCase(get_temp_data.rejected, (state, action) => {
      state.temp_loading = false;
    });
    builder.addCase(get_temp_data.fulfilled, (state, action) => {
      state.temp_loading = false;
      const data = action.payload;
      if (data.success) {
        state.temp_list = data.list;
      } else {
        state.temp_list = [];
      }
    });
  },
});
export default tempSlice.reducer;
